export type DopTariff = {
  goodId: number
  goodName: string
  goodType: number
  price: number
  isActive: boolean
  isConnects: boolean
  serviceId: number
  dateStart: string
  dateEnd: string
}

export enum AvailableTariffGoodType {
  BLOCKED = 2,
  TARIFF = 4,
}

export type AvailableTariff = {
  goodId: number
  goodName: string
  goodType: AvailableTariffGoodType
  price: number
  deviceId: number
  shortDescription: string
  block?: {
    dateEnd: string
    dateStart: string
    serviceId: number
  }
}

export type AvailableTariffsData = {
  title: string
  data: AvailableTariff[]
}
